import { NdtStep, config } from "./helpers";

export default function() {
    return NdtStep('step3b', 'Step 3b: Safe Harbor Provisions Met?', {
        nextComponent: () => 'step4',
        result() {
            if(this.answers.step3a == null) return [];
            return [{ question: this.question, result: this.passed ? 'Pass' : 'Fail' }];
        },
        details() {
            let { eligibleHces, totalNonHces, eligibleNonHces, totalHces } = this.answers;
            
            return [
                { question: 'Step 3b: Number of eligible HCEs', result: eligibleHces },
                { question: 'Step 3b: Total number of All non-HCEs', result: totalNonHces },
                { question: 'Step 3b: Number of eligible non-HCEs', result: eligibleNonHces },
                { question: 'Step 3b: Total number of All HCEs', result: totalHces }
            ]
        },
        passed() {
            var { totalHces, eligibleHces, totalNonHces, eligibleNonHces } = this;

            let harborTable = getHarborTable();
            let concentrationPercentage = getConcentrationPercentage();
            let ratioPercentage = getRatioPercentage();

            let safeHarbor = harborTable[concentrationPercentage].safeHarbor;
            let unsafeHarbor = harborTable[concentrationPercentage].unsafeHarbor;

            return ratioPercentage >= safeHarbor || ratioPercentage >= unsafeHarbor;

            function getConcentrationPercentage() {
                let concentrationPercentage;

                if(totalNonHces === 0 && totalHces === 0)
                    concentrationPercentage = 0;
                else if(totalHces === 0)
                    concentrationPercentage = 99;
                else concentrationPercentage = (totalNonHces / (totalNonHces + totalHces)) * 100;

                concentrationPercentage = Math.max(Math.round(concentrationPercentage), 0);
                return Math.min(concentrationPercentage, 99);
            }

            function getRatioPercentage() {
                let ratioPercentage;

                if(totalNonHces === 0 || eligibleNonHces === 0)
                    ratioPercentage = 0;
                else if(totalHces === 0 || eligibleHces === 0 || (eligibleHces / totalHces) === 0)
                    ratioPercentage = 99;
                else
                    ratioPercentage = ((eligibleNonHces / totalNonHces)) / (eligibleHces / totalHces) * 100;

                return Math.max(Math.round(ratioPercentage), 0);
            }

            function getHarborTable() {
                var harborTable = [];
                for(var i = 0; i < 61; i++)
                    harborTable.push({ safeHarbor: 50, unsafeHarbor: 40 });

                for(var i = 61; i <= 99; i++) {
                    var safe = harborTable[i - 1].safeHarbor - 0.75;
                    var unsafe =  harborTable[i - 1].unsafeHarbor - .75;

                    if(0.75 * (i - 60) > 20) unsafe = 20;
                    
                    harborTable.push({ safeHarbor: safe, unsafeHarbor: unsafe });
                }

                return harborTable;
            }
        },
        nextEnabled() {
            var props = ['eligibleHces', 'totalNonHces', 'eligibleNonHces', 'totalHces']
            return props.every(p => this.answers[p] != null);
        },
        hces: () => [
            'An officer of the employer or',
            'A person owning more than 5% of the employer entity at any point during the current or preceding plan year or',
            config.hce,
            'A spouse or tax dependent of any of the above individuals, who is also employed by the company'
        ],
        template: `
                 <div>
                    <q-title :text="question" />
                     <br/>
                     <div class="px-2 row">
                         <amf-input label="Number of Eligible Non-HCEs" inputType="number" v-model="answers.eligibleNonHces" aggressive/>
                     </div>
                     <div class="px-2 row">
                         <amf-input label="Total number of ALL non-HCEs (this includes all eligible and non-eligible non-HCEs)" inputType="number" v-model="answers.totalNonHces" aggressive/>
                     </div>
                     <div class="px-2 row">
                         <amf-input label="Number of eligible HCEs" inputType="number" v-model="answers.eligibleHces" aggressive/>
                     </div>
                     <div class="px-2 row">
                         <amf-input label="Total number of ALL HCEs (this includes all eligible and non-eligible HCEs)" inputType="number" v-model="answers.totalHces" aggressive/>
                     </div>
                     <div class="px-4 row">
                         <help-block label="An HCE is any of the following:" :items="hces" />
                     </div>
                 </div>`
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step3b.js